import React from "react";
import { Spin } from "antd";

const Loading = () => (
  <div className="Page--full Loader">
    <Spin />
  </div>
);
  
export default Loading;